import { motion } from "framer-motion";

const PROJECTS = [
  {
    title: "Bitcoin Cash Map",
    description:
      "Interactive map showing businesses in Argentina that accept Bitcoin Cash as payment.",
    image: "/projects/bchmap.png",
    tech: ["React", "Node.js", "MapLibre", "Tailwind"],
    url: "https://bchmap.org/",
    repo: "https://github.com/ianblas/bch_map",
  },
  {
    title: "Bean It",
    description:
      "Desktop application for automating bulk email campaigns using Excel data, dynamic variables, and customizable templates.",
    image: "/projects/beanit.png",
    tech: ["React", "Node.js", "Electron"],
    repo: "https://github.com/cherubinifranco/beanit",
  },
];

export default function Projects() {
  return (
    <section
      id="other-projects"
      className="border-t border-white/[0.06] bg-[#010710] px-6 py-24 text-white sm:py-32"
    >
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <h2 className="text-4xl font-medium tracking-[-0.04em] sm:text-5xl">
            More projects
          </h2>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-2">
          {PROJECTS.map((project, index) => (
            <motion.article
              key={project.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                delay: index * 0.1,
                duration: 0.6,
              }}
              className="group"
            >
              {project.url ? (
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group/image relative block overflow-hidden rounded-2xl border border-white/[0.07] bg-[#060B14]"
                  aria-label={`Visit ${project.title}`}
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="h-full w-full object-cover opacity-75 transition duration-700 ease-out group-hover/image:scale-[1.03] group-hover/image:opacity-100"
                    />
                  </div>

                  <div className="absolute inset-0 flex items-center justify-center bg-black/0 transition-all duration-300 group-hover/image:bg-black/50">
                    <span className="translate-y-2 text-sm font-medium text-white opacity-0 transition-all duration-300 group-hover/image:translate-y-0 group-hover/image:opacity-100">
                      Visit <span className="ml-1 text-white/60">↗</span>
                    </span>
                  </div>
                </a>
              ) : (
                <div className="relative overflow-hidden rounded-2xl border border-white/[0.07] bg-[#060B14]">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="h-full w-full object-cover opacity-75 transition duration-700 ease-out group-hover:scale-[1.03] group-hover:opacity-100"
                    />
                  </div>
                </div>
              )}

              <div className="mt-6">
                <div className="flex items-start justify-between gap-6">
                  <div>
                    <h3 className="text-xl font-medium tracking-tight text-white sm:text-2xl">
                      {project.title}
                    </h3>

                    <p className="mt-3 max-w-lg text-sm leading-7 text-white/40">
                      {project.description}
                    </p>
                  </div>

                  <span className="mt-1 shrink-0 text-white/20 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
                    ↗
                  </span>
                </div>

                <div className="mt-6 flex flex-col gap-4 border-t border-white/[0.07] pt-4 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex flex-wrap gap-x-4 gap-y-1">
                    {project.tech.map((tech) => (
                      <span
                        key={tech}
                        className="text-xs uppercase tracking-[0.1em] text-white/25"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  {project.repo && (
                    <a
                      href={project.repo}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs font-medium text-white/30 transition hover:text-white"
                    >
                      Source
                    </a>
                  )}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
